<template>
<div container--fluid>
    <v-layout>
        <InvoiceModule></InvoiceModule>
    </v-layout>
</div>
</template>

<script>
import InvoiceModule from '@modules/invoice/index.vue';

export default {
    name: 'invoice',
    components: {
        InvoiceModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
